import { cloneDeep } from 'lodash';

// Compare old saved dashboards with the defaults used during Trends hydration.
// This does not change the serialized dashboard or its original baseline.
export function normalizeSavedConfig(config: any) {
  const normalized = cloneDeep(config);
  const state = normalized?.state;
  if (!state?.metricsChartContainer) return normalized;
  if (state.metricPanel) {
    state.metricPanel.logAxis ??= false;
    // SavedDashboardHOC gives a truthy root-level key precedence during hydration.
    const usecaseKey = normalized.usecaseKey || state.usecaseKey;
    state.metricPanel.widgetPanelVisibility ??= !usecaseKey;
  }
  state.dimensionPanel = {
    activeTab: 0,
    ...state.dimensionPanel,
    sorts: state.dimensionPanel?.sorts ?? {},
    height: state.dimensionPanel?.height ?? 's',
  };
  return normalized;
}
